import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { OrderDetailsPageContext } from "@insite/content-library/Pages/OrderDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface AdiOrderDetailsTotalStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    orderDetailsTotal?: TypographyProps;
}

export const adiOrderDetailsTotalStyles: AdiOrderDetailsTotalStyles = {
    titleText: {
        variant: "p",
        css: css`
            @media print {
                font-size: 14px;
                color: ${ADIColors.black};
            }
            margin-bottom: 5px;
            font-size: 16px;
            font-weight: bold;
            line-height: 1.13;
        `,
    },
    orderDetailsTotal: {
        css: css`
        font-size: 14px;
        line-height: 1.43;
        font-weight: bold;
        @media print {
            font-size: 13px;
            color: ${ADIColors.black};
        }
        `
    },
    wrapper: {
        css: css`
        ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                                    margin-left: -15px;
                                    white-space: nowrap;
                                `,
                    null
                    ,
                    null,
                ]);
            }}
    `,
    }
};

const styles = adiOrderDetailsTotalStyles;

const ADIOrderDetailsTotal: FC = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText}>
                {translate("Total")}
            </Typography>
            <Typography {...styles.orderDetailsTotal}>
                {order?.statusDisplay !== 'OPEN' ? order?.orderTotalDisplay : order?.productTotalDisplay}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ADIOrderDetailsTotal,
    definition: {
        allowedContexts: [OrderDetailsPageContext],
        group: "Order Details",
    },
};

export default widgetModule;
